import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

import PageAddClient from '../../pages/Clients/Add';

const ModalAddClient = props => {
  const { handleModalClose, showModal } = props;

  return (
    <React.Fragment>
      <Modal
        size="lg"
        show={showModal}
        onHide={handleModalClose}
        animation={true}
      >
        <Modal.Body>
          <PageAddClient handleModalClose={handleModalClose} />
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

ModalAddClient.propTypes = {
  handleModalClose: PropTypes.func,
  showModal: PropTypes.bool
};

export default ModalAddClient;
